export async function getCancelSurvey(csrfToken?: string) {
    const headers: Record<string, string> = {
        "Content-Type": "application/json",
        "Accept": "application/json",
    };

    if (csrfToken) {
        headers["X-CSRF-TOKEN"] = csrfToken;
    }

    const response = await fetch("/account/surveys/offboarding/survey/new", {
        method: "GET",
        headers,
        credentials: "same-origin"
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
}

export async function submitCancelSurvey(surveyData: {
    survey_id: number;
    question_id: number;
    answer_id: number;
    freeform_response_text?: string | null;
}, csrfToken?: string) {
    const headers: Record<string, string> = {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest",
    };

    if (csrfToken) {
        headers["X-CSRF-TOKEN"] = csrfToken;
    }

    const response = await fetch("/account/surveys/responses", {
        method: "POST",
        headers,
        credentials: "same-origin",
        body: JSON.stringify(surveyData)
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
}
